export default __webpack_public_path__ + "static/media/Mark-2-Suit-04.01be3336.jpg";